/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for non-detect counts grouped by detection limit bin.
 * @export
 * @interface NonDetectStats
 */
export interface NonDetectStats {
    /**
     * Detection limit bin: 'under_10' (< 10kg/h), '10_to_50' (10kg/h to < 50kg/h), '50_to_100' (50kg/h to < 100kg/h), '100_to_500' (100kg/h to < 500kg/h) or 'over_500' (>= 500kg/h).
     * @type {string}
     * @memberof NonDetectStats
     */
    bin: string;
    /**
     * Number of non-detect records in bin.
     * @type {number}
     * @memberof NonDetectStats
     */
    count: number;
}

/**
 * Check if a given object implements the NonDetectStats interface.
 */
export function instanceOfNonDetectStats(value: object): value is NonDetectStats {
    if (!('bin' in value) || value['bin'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function NonDetectStatsFromJSON(json: any): NonDetectStats {
    return NonDetectStatsFromJSONTyped(json, false);
}

export function NonDetectStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonDetectStats {
    if (json == null) {
        return json;
    }
    return {
        
        'bin': json['bin'],
        'count': json['count'],
    };
}

export function NonDetectStatsToJSON(json: any): NonDetectStats {
    return NonDetectStatsToJSONTyped(json, false);
}

export function NonDetectStatsToJSONTyped(value?: NonDetectStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bin': value['bin'],
        'count': value['count'],
    };
}

